import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useTransferItem from '../../../utils/useTransferItem';
import Box from '@material-ui/core/Box';
import DataGridPreview from '@afosto/app-components-react/DataGrid/DataGridPreview';
import Property from '@afosto/app-components-react/Property';
import TransportsStepper from '@afosto/app-components-react/TransportsStepper';
import camelize from '@afosto/utils/string/camelize';
import formatDateTime from '@afosto/utils/date/formatDateTime';
import isDefined from '@afosto/utils/isDefined';
import { boolean as booleanFormatter } from '@afosto/app-components-react/DataGrid/formatters';
import translations from './translations';

const OrderItemPreview = ({ isOpen, item, menu, onClose }) => {
  const intl = useIntl();
  const { sku, description, quantity, transfer, claimId, filters = [] } = item ?? {};
  const [transferItem] = useTransferItem(transfer, claimId);

  return (
    <DataGridPreview menu={menu} open={isOpen} onClose={onClose} title={item?.description}>
      <Box px={2}>
        {!!transferItem && (
          <Property
            label={intl.formatMessage(translations.properties.transports)}
            value={
              <Box mt={1}>
                <TransportsStepper
                  transports={transferItem?.transports}
                  routes={transferItem?.route}
                />
              </Box>
            }
          />
        )}

        <Property label={intl.formatMessage(translations.properties.sku)} value={sku} />
        <Property
          label={intl.formatMessage(translations.properties.description)}
          value={description}
        />
        <Property label={intl.formatMessage(translations.properties.quantity)} value={quantity} />
        <Property
          label={intl.formatMessage(translations.properties.isAvailable)}
          value={isDefined(item?.isAvailable) ? booleanFormatter(item?.isAvailable) : undefined}
        />
        <Property
          label={intl.formatMessage(translations.properties.isBackorder)}
          value={isDefined(item?.isBackorder) ? booleanFormatter(item?.isBackorder) : undefined}
        />
        <Property
          label={intl.formatMessage(translations.properties.claimedAt)}
          value={isDefined(item?.claimedAt) ? formatDateTime(item?.claimedAt) : undefined}
        />
        <Property
          label={intl.formatMessage(translations.properties.isInbound)}
          value={isDefined(item?.isInbound) ? booleanFormatter(item?.isInbound) : undefined}
        />
        <Property
          label={intl.formatMessage(translations.properties.isReservation)}
          value={isDefined(item?.isReservation) ? booleanFormatter(item?.isReservation) : undefined}
        />
        {filters.map(({ key, values }) => (
          <Property
            key={key}
            label={intl.formatMessage({
              id: `properties.${camelize(key)}`,
              defaultMessage: key,
              description: `Label for property ${key}`,
            })}
            value={values}
          />
        ))}
      </Box>
    </DataGridPreview>
  );
};

OrderItemPreview.propTypes = {
  isOpen: PropTypes.bool,
  item: PropTypes.object,
  menu: PropTypes.array,
  onClose: PropTypes.func,
};

OrderItemPreview.defaultProps = {
  isOpen: false,
  item: undefined,
  menu: [],
  onClose: undefined,
};

export default OrderItemPreview;
